'use es6';

import PropTypes from 'prop-types';
export const INLINE = 'inline';
export const INLINE_NO_FOOTER = 'inline-no-footer';
export const PANEL = 'panel';
export const UniversalSidebarUsePropType = PropTypes.oneOf([INLINE, INLINE_NO_FOOTER, PANEL]);